module.exports = __webpack_public_path__ + "img/10blue.755f3310.png";